import { get, post, patch, destroy } from './httpClient'

export const getRoles = (query) => get('/role', query)
export const createRole = (body) => post('/role/create', body)
export const updateRole = (id, body) => patch('/role/update/' + id, body)
export const deleteRole = (ids) => destroy('/role/delete', { role_id: ids })
